import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { TranslationService } from '@sdbn/common';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { TransportScope } from "src/tmc-yard/common/model/transport.model";
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';
import { ConfigurationService } from '@sdbn/appclient';

@Component({
  selector: 'app-trailer-swap-source-details',
  templateUrl: './trailer-swap-source-details.component.html',
  styleUrls: ['./trailer-swap-source-details.component.scss']
})
export class TrailerSwapSourceDetailsComponent implements OnInit {

  transportScope = TransportScope;

  stepperModel: AttachDetachStepperModel;

  trailerNumberPlateRequired = false;
  swapTrailerNumberRequired = false;
  detailsForm: FormGroup;

  constructor(
    public translationService: TranslationService,
    public cps: ConfigurationService,
    private stepperService: TransportAttachDetachStepperService
  ) {

    this.stepperModel = this.stepperService.stepperModel;

    this.detailsForm = new FormGroup({
      trailerNumberPlate: new FormControl(null, []),
      swapTrailerNumber: new FormControl(null, []),
    });

    if (this.stepperModel.workingData.targetTransportScope === TransportScope.TRAILER) {
      this.trailerNumberPlateRequired = true;
      this.detailsForm.addControl('trailerNumberPlate', new FormControl(null, [Validators.required]));
      this.detailsForm.addControl('swapTrailerNumber', new FormControl(null, []));
    }

    if (this.stepperModel.workingData.targetTransportScope === TransportScope.SWAP_TRAILER) {
      this.swapTrailerNumberRequired = true;
      this.detailsForm.addControl('swapTrailerNumber', new FormControl(null, [Validators.required]));
    }


    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      return this.detailsForm.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return AttachDetachStepperModel.STEP_SELECT_TRAILER_SWAP_TARGET;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };

    this.detailsForm.reset(
      {
        trailerNumberPlate: this.stepperModel.workingData.trailerNumberPlate,
        swapTrailerNumber: this.stepperModel.workingData.swapTrailerNumber
      }
    );

    this.detailsForm.valueChanges.subscribe(
      values => {
        if (this.detailsForm.dirty) {
          this.stepperModel.workingData.trailerNumberPlate = this.detailsForm.controls.trailerNumberPlate.value;
          this.stepperModel.workingData.swapTrailerNumber = this.detailsForm.controls.swapTrailerNumber.value;
        }
      }
    );
  }

  ngOnInit() {
  }

  isSwapTrailerEnabled() {
    return this.cps.isEnabled(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

}
